module.exports = __webpack_public_path__ + "img/yidong3.e646dcf4.jpg";